import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=5b4b9edc&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b4b9edc')) {
      api.createRecord('5b4b9edc', component.options)
    } else {
      api.reload('5b4b9edc', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=5b4b9edc&", function () {
      api.rerender('5b4b9edc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4kyjKXULHXasP/JS/comp/openstreetmap.vue"
export default component.exports